import React, {useState} from 'react';

import classNames from 'classnames';
import PropTypes from 'prop-types';
import CSSModules from 'react-css-modules';

import {Text} from '@edume/magnificent';

import styles from './styles.module.scss';

function Tabs({defaultActiveItem, items, layz}) {
  const [activeItem, setActiveItem] = useState(
    defaultActiveItem || items[0].id
  );

  return (
    <div styleName='tabs'>
      <ul styleName='tabs-nav'>
        {items.map((item) => (
          <li
            key={`nav-${item.id}`}
            styleName={classNames('tab', {active: item.id === activeItem})}
            onClick={() => {
              setActiveItem(item.id);
            }}
          >
            <Text
              colour='textSecondary'
              lineHeight='tight'
              size='m'
              textTransform='none'
              weight='semiBold'
            >
              {item.title}
              <span styleName='number'>{item.count}</span>
            </Text>
          </li>
        ))}
      </ul>
      {items
        .filter((item) => item.id === activeItem || !layz)
        .map((item) => (
          <div
            key={`item-${item.id}`}
            styleName={classNames('tabs-item', {
              active: item.id === activeItem,
            })}
          >
            {item.content}
          </div>
        ))}
    </div>
  );
}

Tabs.propTypes = {
  defaultActiveItem: PropTypes.string,
  items: PropTypes.array,
  layz: PropTypes.bool,
};

export default CSSModules(Tabs, styles, {allowMultiple: true});
